//src/services/support_assets.js

import API from "./api";

// ✅ Create asset
export const createSupportAsset = async (data, token) => {
  const res = await API.post("/support-assets/", data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};

// ✅ Get all assets
export const getSupportAssets = async () => {
  const res = await API.get("/support-assets/");
  return res.data;
};


// =========================
// CREATOR'S OWN ASSETS
// =========================
export const getMyAssets = async (token) => {
  const res = await API.get(
    "/support-assets/me",
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return res.data;
};